import { Injectable } from '@angular/core';
import { DefaultFormConfig, FormPageActionsService } from '@ptl/forms';
import { SeniorMarketsEnrollmentSubmissionService } from '../../shared/services/enrollment/senior-markets/enrollment-submission.senior-markets';
import { SaveQuoteModalTriggerService } from '../../producer/saved-quotes/services/save-quote-modal-trigger.service';
import { MatDialogRef } from '@angular/material/types/_dialog-chunk';
import { SaveQuoteModalComponent } from '../../producer/save-quote-modal/save-quote-modal.component';
import { UserInfoService } from '../../shared/services/user-info.service';
import { IndividualMarketsEnrollmentSubmissionService } from '../../shared/services/enrollment/individual-markets/enrollment-submission.individual-markets.service';
import { IndividualMarketSaveQuoteUtilityService } from '../../producer/saved-quotes/services/individual-market-save-quote-utility.service';
import { firstValueFrom } from 'rxjs';
import { SubmitAppResponse } from '../../shared/services/enrollment/enrollment-submission.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ShopXFormPageActionsService extends FormPageActionsService {

  constructor(
    private enrollmentSubmissionCallbacks: SeniorMarketsEnrollmentSubmissionService,
    private saveQuoteModalTriggerService: SaveQuoteModalTriggerService,
    private userInfoService: UserInfoService,
    private enrollSubmitIndividualService: IndividualMarketsEnrollmentSubmissionService,
    private individualMarketSaveQuoteUtilityService: IndividualMarketSaveQuoteUtilityService
  ) {
    super();
  }

  async saveForLaterHook(formConfig: DefaultFormConfig): Promise<void | MatDialogRef<SaveQuoteModalComponent, any> | SubmitAppResponse | HttpErrorResponse> {
    if (formConfig.meta.market.toUpperCase() === "SENIOR") {
      await this.enrollmentSubmissionCallbacks.savePayload(
        formConfig.form.customConfigs.saveForLaterPageUrl,
        formConfig.form.customConfigs.forgotPasswordUrl,
        formConfig.form.customConfigs.registrationUrl
      );
    } else if (formConfig.meta.market.toUpperCase() === "INDIVIDUAL") {
      
      const isLoggedIn = await firstValueFrom(this.userInfoService.isLoggedIn$);
            
      // PRODUCER - modal save ( gives rename / new app behavior )
      if (isLoggedIn) {
        return this.saveQuoteModalTriggerService.openSaveQuoteModal({
          modalArgs: this.saveQuoteModalTriggerService.getSaveQuoteModalArgs(formConfig),
          resumptionLandingPage: "enrollPage", // This value is used exactly 1 time, for the plan-details subsequent fetch requests
          formConfig: formConfig
        });
      } else {
        if (formConfig.form.customConfigs.standaloneDocumentUpload === true) {
          // CONSUMER - update existing save, only
          return await this.enrollSubmitIndividualService.saveQuote({
            urls: this.individualMarketSaveQuoteUtilityService.getSavedQuoteConfigsFromResumedApp().urls,
            quoteButtonPage: "enrollPage",
            formConfig: formConfig
          });
        } else {
          throw new Error("standalone consumer save not implemented");
        }

      }
        
    }

  }

}
